var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgValido = function SvgValido(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "valido_svg__Capa_2",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "valido_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7m0-1C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8",
    fill: "#2ad2c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85 7.67 6.9 9.72l4.25-4.24",
    fill: "none",
    stroke: "#2ad2c5",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }))));
};
export default SvgValido;